import React from 'react';
import {Popup, Icon} from 'semantic-ui-react';
import {PerkTransactionTable} from './PerkTransactionTable';

export const PerkTransactionTableList = ({transactions, ascending, handleDateChevron}) => {
        
    return (
        <table className="ui single line table employees" style={{backgroundColor: 'transparent'}}>
            <colgroup>
                    {/* <col style={{width: '5%'}}></col> */}
                    <col style={{width: '18%'}}></col>
                    <col style={{width: '47%'}}></col>
                    <col style={{width: '20%'}}></col>
                    <col style={{width: '15%'}}></col>
                    {/* <col style={{width: '8%'}}></col> */}
                </colgroup>
            <thead>
                
                <tr style={{padding: 20, backgroundColor: 'transparent'}}>
                    <th style={{padding: 20, backgroundColor: 'transparent'}}>
                        Date
                        <Popup content={ascending ? 'Recent Transactions First' : 'Older Transactions First'} style={{paddingLeft: 5}} trigger={
                            <Icon name = {ascending ? 'angle up' : 'angle down'} size='big' color='black'
                                // disabled = {checkCount === 0}
                                onClick = {handleDateChevron}
                            />
                        }/>
                    </th>
                    <th colSpan="1" style={{padding: 20, backgroundColor: 'transparent'}}>Merchant Name</th>
                    <th style={{padding: 20, backgroundColor: 'transparent'}}>Category</th>
                    <th style={{padding: 20, backgroundColor: 'transparent'}}>Amount</th>
                </tr>
            </thead>
            {/* <tbody> */}
            {transactions.map(transaction => <PerkTransactionTable key={transaction['section']} transaction={transaction} />)}
            {/* </tbody> */}
        </table>
    );
};
